import { React, _ } from '../Imports';
import { UserManagementService } from '$State/UserManagementFreezerService';
import { useNavigate } from 'react-router-dom';
import { StandardProtectedRoutePaths, StandardPublicRoutePaths } from '../router/route-sets/standard-route-config';
import { useEffect } from 'react';

const styles = require('./Auth.scss') as {
    main: string;
    authMessage: string;
};

interface ILoginResponseProps {}

const LoginResponse: React.FC<ILoginResponseProps> = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (UserManagementService.isLoggedIn()) {
            navigate(StandardProtectedRoutePaths.VideoEvents);
        } else {
            UserManagementService.tryLogin();
        }
    }, []);

    useEffect(() => {
        if (UserManagementService.isLoggedIn()) {
            navigate(StandardProtectedRoutePaths.VideoEvents);
        }
    }, [UserManagementService.isLoggedIn()]);

    return (
        <div className={styles.main}>
            <div className={styles.authMessage}>
                <div>Response in process... Completing login and redirecting...</div>
            </div>
        </div>
    );
};

export { LoginResponse };
